import { FunctionComponent, memo } from 'react';
import { PollBlockData, PollOptions } from '../../../../shared';

export const PollList: FunctionComponent<PollBlockData> = memo(({ card }) => {
  return <PollOptions card={card} />;
});
